var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChats(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7239 2.00001C10.8958 1.99762 9.10022 2.44038 7.5236 3.28236C5.94699 4.12434 4.64676 5.33486 3.75785 6.78829C2.86894 8.24172 2.42373 9.8851 2.46844 11.5479C2.51314 13.2107 3.04612 14.8323 4.01207 16.2444L1 22L7.32505 19.2596C8.67399 20.0226 10.1993 20.4903 11.7807 20.6256C13.3621 20.761 14.9565 20.5604 16.4382 20.0396C17.9199 19.5189 19.2484 18.6922 20.3191 17.6247C21.3898 16.5572 22.1734 15.2781 22.6082 13.8881C23.043 12.4981 23.1171 11.0353 22.8246 9.61484C22.5321 8.19438 21.8811 6.85512 20.9229 5.70258C19.9646 4.55003 18.7252 3.61569 17.3024 2.97318C15.8797 2.33066 14.3123 1.99753 12.7239 2.00001V2.00001Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChats);
export default __webpack_public_path__ + "static/media/chats.f1ac25e75ec026340a0941689a90f90f.svg";
export { ForwardRef as ReactComponent };